<template>
  <div>                
    <div class="form-switch inline-block align-middle">
      <input 
      type="checkbox" class="form-switch-checkbox"
      v-bind="isToggleOn" 
      v-model="isToggleOn" 
      v-on:change="$emit('input', $event.target.checked)"
      :name="this.idName" 
      :id="this.idName" />

      <label class="form-switch-label" :for="this.idName"></label>
    </div>

    <label 
    :class="{'text-green-dark' : this.isToggleOn,
             'text-grey' : !this.isToggleOn}"
    class="text-md" 
    :for="this.idName">{{ `${ this.isToggleOn ? this.onText : this.offText }` }}</label>
</div>
</template>

<script>
export default {
  name: "TailwindSwitch",
  props: {
    idName: {
      type: String,
      required: true
    },

    onText: {
      type: String,
      required: true
    },

    offText: {
      type: String,
      required: true
    },

    value: {
      type: Boolean,
      default: false,
      required: true
    }
  },

  watch: {
    value: function(newVal, oldVal) {
      // watch it
      this.isToggleOn = newVal;
      console.log('Switch new value -> ' + newVal + ' was ' + oldVal)
    }
  },

  data() {
    return {
      isToggleOn: false
    };
  }

  // mounted() {
  //   this.isToggleOn = this.value;
  //   console.log('Mounted ', this.isToggleOn)
  // },
};
</script>

<style lang="postcss">
/* CHECKBOX TOGGLE SWITCH */
.form-switch {
  @apply relative select-none w-12 mr-2 leading-normal;
}
.form-switch-checkbox {
  @apply hidden;
}
.form-switch-label {
  @apply block overflow-hidden cursor-pointer bg-white border rounded-full h-6  shadow-inner;

  transition: background-color 0.2s ease-in;
}
.form-switch-label:before {
  @apply absolute block bg-white pin-y w-6 border rounded-full -ml-1;

  right: 50%;
  content: "";
  transition: all 0.2s ease-in;
}
.form-switch-checkbox:checked + .form-switch-label,
.form-switch-checkbox:checked + .form-switch-label:before {
}
.form-switch-checkbox:checked + .form-switch-label {
  @apply bg-green shadow-none;
}
.form-switch-checkbox:checked + .form-switch-label:before {
  @apply pin-r;
}
</style>


// WEBPACK FOOTER //
// src/components/TailwindSwitch.vue